import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import { initialFormDataUser, initialErrors, fieldValidation, createUserData  } from '../../common/helper/form-constants.js';
import ConfigService from "../../../services/config-service.js";
import UserService from '../../../services/user-service.js';
import { FormField, SelectField } from './../../common/helper/formFields';

const AddUser = () => {
  const [activeTab, setActiveTab] = useState('per_details');
  const [autoGeneratePassword, setAutoGeneratePassword] = useState(true);
  const [formData, setFormData] = useState({ ...initialFormDataUser });
  const [errors, setErrors] = useState({ ...initialErrors });
  const [loading, setLoading] = useState(false);
  const [statesData,setStatesData] = useState([]);
  const [roles,setRoles] = useState([]);
  const [superVisor,setSuperVisor] = useState([]);
  const [city,setCity] = useState([]);
  const gender = [{ label : 'Male', value : 'M'},{label : 'Female',value : 'F'}]
  const navigate = useNavigate();
  const fetchData = async () => {
    try {
      setLoading(true);
      const [statesResponse, roleResponse, supervisorResponse] = await Promise.all([
        ConfigService.getStates(),
        UserService.getRoles(),
        UserService.getSuperviors(),
      ]);
      const states =  statesResponse.data.data.map(state => ({ value: state.id, label: state.state }));
      const roles = roleResponse.data.data.map(record => ({ value: record.code, label: record.value }));
      const supervisor =  supervisorResponse.data.data.map(record => ({ value: record.key, label: record.value }));
     
      setStatesData(states)
      setRoles(roles)
      setSuperVisor(supervisor)
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
    document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
  }, []);

  const getCities = (stateID) => {
    setLoading(true);
    ConfigService.getCities(stateID)
      .then(response => {
        const cities =  response.data.data.map(city => ({ value: city.id, label: city.city }));
        setCity(cities)
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const validateFields = (fields, formData) => {
    let isValid = true;
    fields.forEach(fieldName => {
      const fieldValue = formData[fieldName];
      if (!fieldValue || !fieldValue.trim()) {
        validateField(fieldName, fieldValue || ''); 
        isValid = false;
      }
    });
    return isValid;
  };

  const handleNext = (current,tab) => {
    let requiredFields = [];
   
    switch (current) {
      case 'per_details':
        requiredFields =['email', 'fullName', 'phoneNumber', 'role_code','date_of_birth', 'supervisor_id', 'gender_id'];
        break;
      case 'address_details':
        requiredFields =['addressLine1', 'city', 'state', 'postalCode'];
        break;
      default:
        break;
    }
    if(!autoGeneratePassword) {
      requiredFields.push('password');
    }
  
    if (!validateFields(requiredFields, formData)) return;
  
    setActiveTab(tab);
  };

  const handlePrevious = (tab) => {
    setActiveTab(tab);
  };
  const addMerchantForm = (e) => {
    e.preventDefault();
    let requiredFields =['addressLine1', 'city', 'state', 'postalCode'];
 
    if (!validateFields(requiredFields, formData)) return;

      const userData =  createUserData(formData, autoGeneratePassword);
      setLoading(true);
      UserService.saveUser(userData)
        .then(response => {
          toast.success(MESSAGES.USR_CREATED);
          navigate('/users')
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          try {
            const errorMessage = error.response.data
            toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
          } catch (e){
            toast.error( MESSAGES.SERVER_ERROR)
          }
        });



  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
    if (name === 'state') {
      getCities(value);
    }
    
   
  };
  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value, autoGeneratePassword);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    return errorMessage;

  };

  const handleAutoGenerate = () => {
    if (!autoGeneratePassword) {
      setErrors(prevErrors => ({ ...prevErrors, adminPassword: '' }));
      setFormData(prevData => ({ ...prevData, adminPassword: '' }));
  }
    setAutoGeneratePassword(!autoGeneratePassword); // Toggle checkbox status

  } 
  function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();
  
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
  
    return `${year}-${month}-${day}`;
  }
  return (
    <div>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
    <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Add User</h4>
    <div className="container-fluid ghty" style={{backgroundColor: 'white'}}>
      <form method="post" id="register_form" action="#" className="merchant_form" onSubmit={addMerchantForm}>
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className={`nav-link ${activeTab === 'per_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_per_details">Personal Information</a>
          </li>
          <li className="nav-item tbbtrn">
            <a className={`nav-link ${activeTab === 'address_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_address_details">Address</a>
          </li>
 
        </ul>
        <div className="tab-content" style={{marginTop: '16px'}}>
          <div className={`tab-pane ${activeTab === 'per_details' ? 'active' : 'fade'}`} id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="f_name">FULL NAME</label>
                      <input type="text" className="form-control" id="f_name" placeholder="Enter Full Name" name="f_name" />
                      <span id="error_fname" className="text-danger" /> */}
                       <FormField
                           type="text"
                           isRequierd = {true}
                           id="f_name"
                           name="fullName"
                           label="FULL NAME"
                           placeholder = "Enter Full Name"
                           value={formData.fullName}
                           onChange={handleChange}
                           error={errors.fullName}
                           maxlength = {20}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                      <FormField
                           type="text"
                           isRequierd = {true}
                           id="phone"
                           name="phoneNumber"
                           label="PHONE NUMBER"
                           placeholder = "Enter Phone Number"
                           value={formData.phoneNumber}
                           onChange={handleChange}
                           error={errors.phoneNumber}
                           maxlength = {10}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left', marginTop:'30px'}}>
                    <SelectField 
                                id="searchTransaction"
                                isRequierd = {true}
                                name="gender_id"
                                label="GENDER"
                                selectedField = "Select Gender"
                                value={formData.gender_id}
                                onChange={handleChange}
                                error={errors.gender_id}
                                options={gender}
                                />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      
                    <FormField
                           type="date"
                           isRequierd = {true}
                           id="date_of_birth"
                           name="date_of_birth"
                           label="DATE OF BIRTH"
                           placeholder = "Enter DOB"
                           value={formData.date_of_birth}
                           onChange={handleChange}
                           error={errors.date_of_birth}
                           max={getCurrentDate()}
                        />
                    </div>
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="email">E-MAIL</label>
                      <input type="email" className="form-control" id="email" placeholder="Enter Email" name="email" />
                      <span id="error_email" className="text-danger" /> */}
                       <FormField
                           type="email"
                           isRequierd = {true}
                           id="email"
                           name="email"
                           label="E-mail"
                           placeholder = "Enter Email"
                           value={formData.email}
                           onChange={handleChange}
                           error={errors.email}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="email">MERCHANT ADMIN PASSWORD</label>
                      <input type="password" className="form-control nhjgf" id="admin_password" defaultValue="password" name="admin_password" disabled /> */}

                        <FormField
                           type="password"
                           isRequierd = {true}
                           id="password"
                           name="password"
                           label="PASSWORD"
                           placeholder = "Enter password"
                           value={formData.password}
                           onChange={handleChange}
                           error={errors.password}
                           disabled={autoGeneratePassword}
                           maxlength={15}
                        />
                      <i style={{display: 'none'}} className="toggle-password fa fa-fw fa-eye-slash" />
                      <span id="error_admin_password" className="text-danger" />
                      <p><input type="checkbox" onChange={handleAutoGenerate} style={{position: 'absolute'}} className="fchk myCheckbox"  defaultChecked={autoGeneratePassword} />
                        <span style={{marginLeft: '30px', color: '#495a69', marginTop: '6px', position: 'absolute', fontSize: '13px', fontWeight: 600}}>Auto Generate Password</span></p>
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left', marginTop:'30px'}}>
                    <SelectField 
                                id="role_code"
                                isRequierd = {true}
                                name="role_code"
                                label="ROLE"
                                selectedField = "Select Role"
                                value={formData.role_code}
                                onChange={handleChange}
                                error={errors.role_code}
                                options={roles}
                                />
                        </div>

                        <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                                id="supervisor_id"
                                isRequierd = {true}
                                name="supervisor_id"
                                label="Supervisor"
                                selectedField = "Select Supervisor"
                                value={formData.supervisor_id}
                                onChange={handleChange}
                                error={errors.supervisor_id}
                                options={superVisor}
                                />
                        </div>


                  </div>
                </div>
                <br />
                <div align="left">
                  <button type="button" name="btn_login_details" id="btn_login_details" className="btn ddfg" onClick={() => handleNext('per_details','address_details')}>Next</button>
                </div>
                <br />
              </div>
            </div>
          </div>
          <div className={`tab-pane ${activeTab === 'address_details' ? 'active' : 'fade'}`} id="address_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="f_name">ADDRESS LINE 1</label>
                      <input type="text" className="form-control" id="address_1" placeholder="Enter Address" name="address_1" />
                      <span id="error_address_1" className="text-danger" /> */}
                      <FormField
                           type="text"
                           isRequierd = {true}
                           id="addressLine1"
                           name="addressLine1"
                           label="ADDRESS LINE 1"
                           placeholder = "Enter Address"
                           value={formData.addressLine1}
                           onChange={handleChange}
                           error={errors.addressLine1}
                           maxlength = {50}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                       id="state"
                       isRequierd = {true}
                       name="state"
                       label="STATE"
                       selectedField = "Select State"
                       value={formData.state}
                       onChange={handleChange}
                       error={errors.state}
                       options={statesData}
                    />
                     
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {true}
                           id="postalCode"
                           name="postalCode"
                           label="POSTAL CODE"
                           placeholder = "Enter Postal Code"
                           value={formData.postalCode}
                           onChange={handleChange}
                           error={errors.postalCode}
                           maxlength = {6}
                        />
                     
                    </div>
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {false}
                           id="addressLine2"
                           name="addressLine2"
                           label="ADDRESS LINE 2"
                           placeholder = "Enter Address"
                           value={formData.addressLine2}
                           onChange={handleChange}
                           error={errors.addressLine2}
                           maxlength = {50}
                        />
                      {/* <label className="required" htmlFor="email">ADDRESS LINE 2</label>
                      <input type="email" className="form-control" id="address_2" placeholder="Enter Address" name="email" />
                      <span id="error_address_2" className="text-danger" /> */}
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="Transaction">STATE/PROVINCE</label>
                      <select name="state" className="drp" id="state">
                        <option value>Select State</option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                      </select>
                      <span id="error_state" className="text-danger" /> */}
                       <SelectField 
                       id="city"
                       isRequierd = {true}
                       name="city"
                       label="CITY"
                       selectedField = "Select City"
                       value={formData.city}
                       onChange={handleChange}
                       error={errors.city}
                       options={city}
                    />
                      
                    </div>
         
                  </div>
                </div>
                <br />
                <div align="left">
                <button type="button" name="previous_btn_amin_details" id="previous_btn_amin_details" className="btn ddfgg"  onClick={() => handlePrevious('per_details')}>Previous</button>
                  <button type="sumbit" name="btn_asubmit" id="btn_asubmit" className="btn ddfg">Submit</button>
                </div>
                <br />
              </div>
            </div>
          </div>

        </div>
      </form>
    </div>
  </div>
  </div>
  );


  }


export default withAuth(AddUser);
